import { defineMessages } from 'react-intl'

const messages = {
  title: {
    id: 'app.components.order-consolidate-modal.consolidate',
    defaultMessage: 'Consolidate',
  },
  button: {
    id: 'app.components.order-consolidate-modal.button',
    defaultMessage: 'Select the items you want to consolidate',
  },
  consolidateItems: {
    id: 'app.components.order-consolidate-modal.consolidate-items',
    defaultMessage: `Consolidate { amount, number } { amount, plural,
      one { item }
      other { items }
    }`,
  },
}

export default defineMessages(messages)
